module.exports = __webpack_public_path__ + "img/SH.1a3555d9.svg";